import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ClassQuiz from "./ClassQuiz";
import ViewQuizzes from "./ViewQuizzes";
import ViewQuizAnswers from "./ViewQuizAnswers";
import ExpandQuizzes from "./ExpandQuizzes";
import PracticeQuiz from "../quiz/PracticeQuiz";

const StudentClassQuizRouter = () => {
  return (
    <Routes>
      <Route index element={<ClassQuiz />} />
      <Route path="view" element={<ViewQuizzes />} />
      <Route path="view/:id" element={<ViewQuizAnswers />} />
      <Route path="expand/:id" element={<ExpandQuizzes />} />
      <Route path="take/:id" element={<PracticeQuiz />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default StudentClassQuizRouter;
